<template>
  <div class="notice-box">
    <div class="notice">
      <div><span>主办单位：</span>徐州市科学技术局</div>
      <div><span>承办单位：</span>徐州市高新技术创业服务中心</div>
      <!-- <div>徐州市生产力促进中心</div> -->
      <!-- <div>徐州市高新技术创业服务中心</div> -->
      <div><span>技术支持：</span>星睿创客实验室systarlab</div>
      <div><span>支持热线：</span>0516-85867000、400-178-6988、15312645813</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "noticeBox"
};
</script>

<style lang="stylus" scoped>
.notice-box
  text-align center
  .notice
    display inline-block
    padding 0 15px
    font-size 14px
    text-align left
    margin-top 40px
    line-height 24px
    color #666666
    div
      position relative
      padding-left 68px
      span
        position absolute
        left 0
        top 0
        display block
</style>
